import { composeWithDevTools } from '@redux-devtools/extension';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducers';
import { config } from '../config/config';

const devToolsOptions = {
  maxAge: 20,
  latency: 1000,

  actionSanitizer: (action) => {
    if (action?.type === 'SET_PORTAL_WRAPPERS') {
      return {
        ...action,
        payload: '<<DOM_REF_HIDDEN_FOR_DEVTOOLS>>',
      };
    }
    return action;
  },

  stateSanitizer: (state) => {
    if (!state) return state;

    if ('portalWrappers' in state) {
      return {
        ...state,
        portalWrappers: '<<DOM_REF_ACTIVE_IN_APP>>',
      };
    }
    return state;
  },
};

const store =
  process.env.NODE_ENV === 'development' || config?.reduxDevToolsEnabled
    ? createStore(reducer, composeWithDevTools(devToolsOptions)(applyMiddleware(thunk)))
    : createStore(reducer, applyMiddleware(thunk));

export default store;
